<template>
  <div id="push-model-div">
    <div class="app-modal" id="pushdiscount" style="z-index:999999999;">
      <div class="app-modal-wrap">
        <div
          class="app-modal pushdiscount-dialog"
          id="activity-model-dialog"
          style="z-index:999999999;justify-content:center;display:flex;"
        >
          <div
            class="app-modal-wrap"
            style="align-self:center;display:flex;flex-direction:column;position:relative"
          >
            <div v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "pushumessage_dialog",
  components: {},
  props: ["content"],
  data() {
    return {
      ishow: true
    };
  },
  watch: {
    // $route(to) {}
  },
  computed: {},
  mounted() {
    try {
      $("#push-model-div i").click(function() {
        $("#push-model-div").remove();
      });
    } catch {
      console.log("异常了");
    }
  },
  updated() {},
  methods: {}
};
</script>

<style lang="less" scoped>
#push-model-div {
  .app-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: table;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
    transition: opacity 0.2s ease;
  }
  .app-modal-wrap {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }
}
/deep/#push-model-div .close-icon {
  position: absolute !important;
  align-self: flex-end !important;
  cursor: pointer !important;
}
</style>
